import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

const values = [
  {
    icon: "ri-stack-line",
    title: "内容丰富",
    desc: "聚合电影、电视剧、综艺等多元影视资源，覆盖多种题材与风格。",
  },
  {
    icon: "ri-search-eye-line",
    title: "查找便捷",
    desc: "清晰分类、智能筛选与即时搜索，帮你快速定位想看的作品。",
  },
  {
    icon: "ri-heart-3-line",
    title: "体验友好",
    desc: "简洁大气的界面与流畅的浏览体验，全端适配，随手可用。",
  },
];

export default function About() {
  useSEO({
    title: "关于我们 - 粉色视频",
    description:
      "粉色视频是专业的视频内容聚合平台，致力于为用户提供电影、电视剧、综艺等多元内容的浏览、查找与观看引导服务。了解我们的定位与联系方式。",
    keywords: "关于粉色视频,粉色视频介绍,视频聚合平台,联系我们",
  });

  return (
    <div className="w-full">
      <div className="bg-primary-50">
        <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
          <nav className="flex flex-wrap items-center gap-1 text-xs text-foreground-500">
            <Link to="/" className="cursor-pointer hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <h1 className="mt-3 text-3xl font-black text-foreground-950 md:text-4xl">关于粉色视频</h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            粉色视频是一个专业的视频内容聚合平台，专注于为用户提供丰富多样的视频内容浏览、查找与观看引导服务。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
        <section className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-flag-line"></i>
              网站定位
            </span>
            <h2 className="mt-4 text-xl font-black text-foreground-950 md:text-2xl">
              让每一次发现，都轻松愉快
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              粉色视频定位于集电影、电视剧、综艺等丰富视频资源展示和查找功能于一体的在线视频聚合平台。
              我们的目标用户是广大影视内容爱好者，涵盖寻求最新影视作品、热门综艺节目以及经典电影的各年龄层观众。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们重视视频内容的多样性和便捷的搜索体验，旨在为用户提供直观有效的视频内容浏览、快速定位和观看引导服务，
              持续提升用户的视觉娱乐体验。网站采用现代门户风格，兼顾便捷性与专业感。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="rounded-lg bg-background-100 p-6">
                <p className="text-2xl font-black text-primary-500 md:text-3xl">12,000+</p>
                <p className="mt-2 text-sm text-foreground-600">聚合影视资源</p>
              </div>
              <div className="rounded-lg bg-secondary-50 p-6">
                <p className="text-2xl font-black text-accent-500 md:text-3xl">每日更新</p>
                <p className="mt-2 text-sm text-foreground-600">持续上新内容</p>
              </div>
            </div>
          </div>

          <aside className="rounded-lg border border-background-200/80 p-6">
            <h2 className="text-base font-bold text-foreground-950">联系我们</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              在使用过程中如有任何建议或合作意向，欢迎通过以下方式与我们取得联系。
            </p>
            <ul className="mt-5 space-y-4">
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-mail-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">邮箱</p>
                  <p className="text-sm font-medium text-foreground-900">hello@pinkvideo.example.com</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-customer-service-2-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">合作咨询</p>
                  <p className="text-sm font-medium text-foreground-900">partner@pinkvideo.example.com</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className="ri-map-pin-line"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">办公地址</p>
                  <p className="text-sm font-medium text-foreground-900">中国 · 上海市 · 数字文创园区</p>
                </div>
              </li>
            </ul>
            <Link
              to="/"
              className="mt-6 flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-message-2-line"></i>
              在线留言（演示）
            </Link>
          </aside>
        </section>

        <section className="mt-14">
          <h2 className="text-xl font-black text-foreground-950 md:text-2xl">我们的坚持</h2>
          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200/80 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-14 rounded-lg bg-background-100 p-6 md:p-8">
          <h2 className="text-base font-bold text-foreground-950">版权与免责声明</h2>
          <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
            <p>
              1. 本网站为内容聚合与展示的演示平台，站内所有影视作品的名称、封面、简介、演职人员等信息均为虚构演示数据，
              仅用于展示产品功能与界面效果，不代表任何真实作品。
            </p>
            <p>
              2. 本站暂不提供真实的视频播放、下载、用户登录或在线支付功能，页面中的播放区域为演示示意，
              相关提示均明确标注为演示状态。
            </p>
            <p>
              3. 收藏功能仅在用户本地浏览器中保存，不会上传至服务器，清除浏览器数据后收藏记录将被移除。
            </p>
            <p>4. 如本平台内容涉及任何权利问题，请通过上述联系方式与我们沟通，我们将及时处理。</p>
          </div>
        </section>
      </div>
    </div>
  );
}